import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "Nova Zgodba",
    ongoingStories: "Zgodbe v Teku",
    completedStories: "Zaključene Zgodbe",
    publicStories: "Javne Zgodbe",
    loadingStory: "Nalaganje Zgodbe",
    pleaseWait: "Prosimo počakajte, da naložimo vašo zgodbo",
    newCharacter: "Nov Lik",
    characterCard: {
      personality: "Osebnost",
      strengths: "Prednosti",
      weaknesses: "Slabosti",
      skills: "Veščine"
    },
    search: {
      placeholder: "Iskanje zgodb po naslovu...",
      characters: "Iskanje likov..."
    },
    filters: {
      title: "Filtri",
      reset: "Ponastavi",
      apply: "Uporabi",
      sortBy: "Razvrsti po",
      filterByRole: "Filtriraj po vlogi",
      name: "Ime",
      role: "Vloga",
      dateCreated: "Datum nastanka",
      rating: "Ocena",
      allRoles: "Vse Vloge",
      roles: {
        all: "Vse vloge",
        protagonist: "Glavni lik",
        antagonist: "Antagonist",
        deuteragonist: "Stranski lik",
        mentor: "Mentor",
        comic_relief: "Komični lik",
        mysterious: "Skrivnostna oseba",
        love_interest: "Ljubezenski interes",
        anti_hero: "Anti-junak",
        sidekick: "Pomočnik",
        shapeshifter: "Spreminjač oblike",
        guardian: "Varuh",
        catalyst: "Katalizator",
        character: "Lik",
        supporting: "Podporni lik"
      }
    },
    deleteStory: {
      confirmTitle: "Izbriši Zgodbo",
      confirmMessage: "Ali ste prepričani, da želite izbrisati to zgodbo? Tega dejanja ni mogoče razveljaviti.",
      success: "Zgodba izbrisana",
      successMessage: "Zgodba je bila uspešno izbrisana.",
      error: "Napaka",
      errorMessage: "Zgodbe ni bilo mogoče izbrisati. Poskusite znova."
    },
    navigation: {
      stories: "Zgodbe",
      characters: "Liki",
      publicStories: "Javne Zgodbe",
      stats: "Statistike",
      more: "Več"
    },
    loadingCharacters: "Nalaganje likov...",
    noCharactersFound: "Ni najdenih likov",
    createCharacter: {
      new: "Nov Lik",
      title: "Ustvari Novega Lika",
      editTitle: "Uredi Lika",
      basicDetails: "Osnovni Podatki",
      characteristics: "Značilnosti",
      avatarDetails: "Podrobnosti Avatarja",
      personalityTraits: "Osebnostne Lastnosti",
      form: {
        name: "Ime",
        namePlaceholder: "Vnesite ime lika",
        description: "Opis",
        descriptionPlaceholder: "Vnesite opis lika",
        role: "Vloga",
        selectRole: "Izberite vlogo lika",
        personality: "Osebnost",
        personalityTraits: "Osebnostne lastnosti",
        personalityPlaceholder: "Vnesite osebnostne lastnosti",
        strengths: "Prednosti",
        strengthsPlaceholder: "Vnesite prednosti lika",
        weaknesses: "Slabosti",
        weaknessesPlaceholder: "Vnesite slabosti lika",
        skills: "Veščine",
        skillsPlaceholder: "Vnesite veščine lika",
        addTrait: "Dodaj Lastnost",
        addStrength: "Dodaj Prednost",
        addWeakness: "Dodaj Slabost",
        addSkill: "Dodaj Veščino",
        "add.Personality.Traits": "Dodaj Osebnostne Lastnosti",
        "add.Strengths": "Dodaj Prednosti",
        "add.Weaknesses": "Dodaj Slabosti",
        "add.Skills": "Dodaj Veščine",
        unnamedCharacter: "Neimenovan Lik",
        cancel: "Prekliči",
        create: "Ustvari Lika",
        update: "Posodobi Lika"
      },
      buttons: {
        create: "Ustvari Lika",
        update: "Posodobi Lika",
        cancel: "Prekliči",
        updating: "Posodabljanje...",
        creating: "Ustvarjanje...",
      },
      avatarGenerator: {
        genderLabel: "Vrsta Videza",
        genderPlaceholder: "Izberite vrsto videza",
        ageLabel: "Starostna Skupina",
        agePlaceholder: "Izberite starostno skupino",
        hairLabel: "Opis Las",
        hairPlaceholder: "npr., Dolge kodraste črne lase",
        eyeLabel: "Barva Oči",
        eyePlaceholder: "npr., Globoko modre",
        clothingLabel: "Slog Oblačil",
        clothingPlaceholder: "npr., Srednjeveški oklep",
        expressionLabel: "Izraz Obraza",
        expressionPlaceholder: "npr., Samozavesten nasmeh",
        generateButton: "Ustvari Avatar",
        generating: "Ustvarjanje...",
        previewLabel: "Ustvarjen Avatar",
        selectTitle: "Izberi Avatar",
        selectDescription: "Izberite enega od ustvarjenih avatarjev za vašega lika.",
        partialSuccess: "Nekateri avatarji so bili uspešno ustvarjeni",
        someImagesFailed: "Nekateri avatarji niso bili uspešno ustvarjeni",
        selectPreferred: "Izberite želenega",
        genderOptions: {
          male: "Človek - Moški",
          female: "Človek - Ženska",
          // New animal options
          cat: "Žival - Mačka",
          dog: "Žival - Pes",
          wolf: "Žival - Volk",
          fox: "Žival - Lisica",
          rabbit: "Žival - Zajec",
          bird: "Žival - Ptica",
          reptile: "Žival - Plazilec",
          // Existing fantasy options
          elf: "Fantazija - Vilinec",
          dwarf: "Fantazija - Palček",
          orc: "Fantazija - Ork",
          vampire: "Fantazija - Vampir",
          werewolf: "Fantazija - Volkodlak",
          fairy: "Fantazija - Vila",
          angelic: "Fantazija - Angelsko bitje",
          demonic: "Fantazija - Demonsko bitje",
          dragonborn: "Fantazija - Zmajski potomec",
          centaur: "Fantazija - Kentaver",
          mermaid: "Fantazija - Morska deklica/Morski mož",
          humanoid_alien: "Znanstvena fantastika - Humanoidni nezemljan",
          insectoid_alien: "Znanstvena fantastika - Insektoidni nezemljan",
          reptilian_alien: "Znanstvena fantastika - Reptilski nezemljan",
          cyborg: "Znanstvena fantastika - Robot/Kiborg",
          energy_being: "Znanstvena fantastika - Energijsko bitje",
          tentacled: "Znanstvena fantastika - Lovkasto bitje",
          cat_person: "Živalsko - Mačja oseba",
          dog_person: "Živalsko - Pasja oseba",
          wolf_person: "Živalsko - Volčja oseba",
          fox_person: "Živalsko - Lisičja oseba",
          rabbit_person: "Živalsko - Zajčja oseba",
          bird_person: "Živalsko - Ptičja oseba",
          reptile_person: "Živalsko - Plazilska oseba",
          treant: "Mitološko - Hodeče drevo",
          flower: "Mitološko - Zavestna roža",
          vine: "Mitološko - Živa vinska trta",
          mushroom: "Mitološko - Govoreča goba",
          vegetable: "Mitološko - Oživljena rastlina",
          golem: "Mitološko - Golem",
          ghost: "Mitološko - Duh",
          shapeshifter: "Mitološko - Spreminjač oblike"
        },
        ageOptions: {
          child: "Otrok",
          teen: "Najstnik",
          adult: "Odrasel",
          elderly: "Starejši"
        },
        success: {
          title: "Avatar Ustvarjen",
          description: "Avatar vašega lika je bil uspešno ustvarjen."
        },
        error: {
          title: "Napaka pri ustvarjanju",
          description: "Avatarja ni bilo mogoče ustvariti. Poskusite znova."
        },
        upload: {
          button: "Naloži Avatar",
          uploading: "Nalaganje...",
          success: {
            title: "Avatar naložen",
            description: "Vaš avatar je bil uspešno naložen"
          },
          error: {
            title: "Napaka pri nalaganju",
            fileTooLarge: "Slika avatarja mora biti manjša od 5MB",
            invalidType: "Prosimo, naložite slikovno datoteko",
            failed: "Napaka pri nalaganju slike avatarja"
          },
          loading: "Nalaganje slike..."
        }
      },
      messages: {
        successCreated: {
          title: "Lik Ustvarjen",
          description: "Vaš lik je bil uspešno shranjen.",
        },
        successUpdated: {
          title: "Lik Posodobljen",
          description: "Vaš lik je bil uspešno posodobljen.",
        },
        errorLoad: {
          title: "Napaka",
          description: "Napaka pri nalaganju podatkov lika",
        },
        errorSave: {
          title: "Napaka",
          description: "Napaka pri shranjevanju lika. Poskusite znova.",
        },
        validation: {
          characterName: {
            title: "Manjkajoče Ime",
            description: "Ime lika je obvezno.",
          },
        },
      },
    },
    characterTabs: {
      myCharacters: "Moji Liki",
      publicCharacters: "Javni Liki"
    },
    characterManagement: {
      delete: {
        title: "Izbriši Lika",
        confirmMessage: "Ali ste prepričani, da želite izbrisati tega lika? Tega dejanja ni mogoče razveljaviti.",
        cancel: "Prekliči",
        delete: "Izbriši",
        deleting: "Brisanje...",
        success: {
          title: "Lik izbrisan",
          description: "Lik je bil uspešno izbrisan"
        },
        error: {
          title: "Napaka",
          description: "Napaka pri brisanju lika"
        }
      },
      visibility: {
        setPrivate: "Lik nastavljen kot zaseben",
        setPublic: "Lik nastavljen kot javen",
        nowPrivate: "Lik je zdaj zaseben",
        nowPublic: "Lik je zdaj viden vsem",
        error: "Napaka",
        updateFailed: "Napaka pri posodabljanju vidnosti lika"
      },
      rating: {
        submitted: "Ocena oddana",
        thankYou: "Hvala za oceno tega lika!",
        error: "Napaka",
        failed: "Ocene ni bilo mogoče oddati"
      }
    },
    suggestions: {
      personalities: {
        adaptable: "Prilagodljiv",
        ambitious: "Ambiciozen",
        brave: "Pogumen",
        charismatic: "Karizmatičen",
        compassionate: "Sočuten",
        confident: "Samozavesten",
        creative: "Ustvarjalen",
        determined: "Odločen",
        diplomatic: "Diplomatski",
        empathetic: "Empatičen",
        honorable: "Časten",
        humble: "Skromen",
        humorous: "Humorističen",
        innovative: "Inovativen",
        loyal: "Zvest",
        optimistic: "Optimističen",
        patient: "Potrpežljiv",
        resilient: "Odporen",
        wise: "Moder",
        analytical: "Analitičen",
        cautious: "Previden",
        eccentric: "Ekscentričen",
        mysterious: "Skrivnosten",
        pragmatic: "Pragmatičen",
        reserved: "Zadržan",
        stoic: "Stoičen",
        arrogant: "Aroganten",
        cynical: "Ciničen",
        greedy: "Pohlepen",
        hot_tempered: "Vročekrven",
        impulsive: "Impulziven",
        manipulative: "Manipulativen",
        obsessive: "Obsesiven",
        paranoid: "Paranoidni",
        prideful: "Ponosen",
        reckless: "Nepremišljen",
        ruthless: "Brezobziren",
        vengeful: "Maščevalen"
      },
      skills: {
        leadership: "Vodenje",
        negotiation: "Pogajanje",
        perception: "Zaznavanje",
        persuasion: "Prepričevanje",
        investigation: "Preiskovanje",
        survival: "Preživetje",
        deception: "Prevara",
        intimidation: "Ustrahovanje",
        performance: "Nastopanje",
        medicine: "Medicina",
        sword_fighting: "Mečevanje",
        archery: "Lokostrelstvo",
        martial_arts: "Borilne veščine",
        stealth: "Skrivanje",
        acrobatics: "Akrobatika",
        marksmanship: "Ostrostrelstvo",
        hand_to_hand: "Rokovanje",
        tactical: "Taktičnost",
        magic: "Čarovnija",
        elemental_control: "Nadzor elementov",
        healing: "Zdravljenje",
        necromancy: "Nekromantija",
        prophecy: "Prerokovanje",
        shapeshifting: "Spreminjanje oblike",
        telepathy: "Telepatija",
        telekinesis: "Telekineza",
        alchemy: "Alkimija",
        summoning: "Priklicanje",
        hacking: "Vdiranje",
        piloting: "Pilotiranje",
        robotics: "Robotika",
        cybernetics: "Kibernetika",
        nanotech: "Nanotehnologija",
        quantum_physics: "Kvantna fizika",
        ai_programming: "AI programiranje",
        bioengineering: "Bioinženiring",
        time_manipulation: "Manipulacija časa",
        energy_weapons: "Energijsko orožje",
        crafting: "Obrtništvo",
        cooking: "Kuhanje",
        music: "Glasba",
        art: "Umetnost",
        writing: "Pisanje",
        forgery: "Ponarejanje",
        invention: "Izumljanje",
        linguistics: "Jezikoslovje",
        history: "Zgodovina",
        science: "Znanost",
        psychology: "Psihologija",
        archaeology: "Arheologija",
        cryptography: "Kriptografija",
        strategy: "Strategija",
        mythology: "Mitologija",
        economics: "Ekonomija"
      }
    },
    upgradeForMore: "Nadgradite za več",
    storiesRemaining: "Preostale zgodbe",
    storiesAvailable: "Razpoložljive zgodbe",
    by: "avtor",
    anonymous: "Anonimno",
    completed: "Zaključeno",
    public: "Javno",
    makePublic: "Objavi",
    makePrivate: "Naredi zasebno",
    upgradeToMakePublic: "Nadgradite za objavo zgodb",
    error: "Napaka",
    rating: {
      submitted: "Ocena oddana",
      thankYou: "Hvala za oceno te zgodbe!",
      failed: "Ocene ni bilo mogoče oddati"
    },
    upgrade: {
      required: "Potrebna je nadgradnja",
      description: "Nadgradite svoj račun, da objavite zgodbe in jih delite z drugimi.",
      shareStories: "Delite svoje zgodbe s premium naročnino",
      now: "Nadgradi zdaj"
    },
    startedTime: "Začeto {{time}}",
    storyVisibility: {
      madePublic: "Zgodba je objavljena",
      madePrivate: "Zgodba je zasebna", 
      publicDescription: "Drugi lahko zdaj vidijo to zgodbo",
      privateDescription: "Ta zgodba je zdaj zasebna"
    },
    stats: {
      tabs: {
        badges: "Značke",
        stories: "Zgodbe",
        characters: "Liki",
        engagement: "Angažiranost"
      },
      badges: {
        loading: "Nalaganje značk...",
        earned: "Zasluženo:",
        error: {
          title: "Napaka",
          loadBadges: "Napaka pri nalaganju značk",
          loadProgress: "Napaka pri nalaganju napredka značk"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "Plodovit Pisec",
            description: "Dokončajte 100 zgodb",
            category: "Pisanje"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "Zgodovinski Romanopisec",
            description: "Dokončajte 3 zgodbe zgodovinske fikcije",
            category: "Žanri"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "Vzdržljivostni Pisec",
            description: "Pišite odgovore 30+ dni zapored",
            category: "Pisanje"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "Reševalec Skrivnosti",
            description: "Dokončajte 10 detektivskih zgodb",
            category: "Žanri"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "Arhitekt Dialogov",
            description: "Prispevajte 10.000 besed dialoga preko interakcij",
            category: "Pisanje"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "Vrhunski Kritik",
            description: "Ocenite 20 likov",
            category: "Skupnost"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "Graditelj Odnosov",
            description: "Ustvarite odnose med 5 liki",
            category: "Liki"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "Viralna Senzacija",
            description: "Zgodba doseže 1.000+ ogledov",
            category: "Družbeno"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "Globok Mislec",
            description: "Dodajte podrobno ozadje 3 likom",
            category: "Liki"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "Družabni Metulj",
            description: "Ocenite 20 zgodb",
            category: "Skupnost"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "Ljubitelj Grozljivk",
            description: "Dokončajte 20 grozljivk",
            category: "Žanri"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "Začetnik Serij",
            description: "Objavite prvo zgodbo v večdelni seriji",
            category: "Pisanje"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "Uravnoteženi Glas",
            description: "Dosežite več odgovorov, ki jih je uredil uporabnik",
            category: "Pisanje"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "Mojster Priporočil",
            description: "Povabi in pridobi 10 prijateljev, da se pridružijo",
            category: "Družbeno"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "Spodbujevalec",
            description: "Dajte 20+ pozitivnih odzivov na zgodbe",
            category: "Skupnost"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "Mojster Namigov",
            description: "Zagotovite 100 edinstvenih uporabniških namigov",
            category: "Pisanje"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "Promotor",
            description: "Delite 5 zgodb na družbenih omrežjih",
            category: "Družbeno"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "AI Šepetalec",
            description: "Sprejmite 500-krat odgovore, ki jih je ustvaril AI",
            category: "Pisanje"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "Umetnik Likov",
            description: "Ustvarite avatar za lik",
            category: "Liki"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "Dnevni Pisatelj",
            description: "Ustvarite zgodbo 7 zaporednih dni",
            category: "Pisanje"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "Dinamična Zasedba",
            description: "Uporabite 20+ različnih likov v zgodbah",
            category: "Liki"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "Eksperimentator",
            description: "Dokončajte 10+ različnih žanrov v zgodbah",
            category: "Žanri"
          }
        }
      },
      storyStats: {
        loading: "Nalaganje statistike...",
        totalStories: "Skupno Zgodb",
        completed: "Zaključene",
        published: "Objavljene",
        averageRating: "Povprečna Ocena",
        categoryRelationships: "Odnosi med Kategorijami",
        primaryCategory: "Primarna Kategorija",
        secondaryCategory: "Sekundarna Kategorija",
        selectCategory: "Izberite kategorijo",
        genre: "Žanr",
        themes: "Teme",
        environment: "Okolje",
        noCategoryData: "Ni podatkov o kategorijah",
        lessFrequent: "Manj pogosto",
        moreFrequent: "Bolj pogosto",
        usageDescription: "Prikazuje, kako pogosto se kategorije uporabljajo skupaj v vaših zgodbah",
        stories: "zgodb",
        noDataAvailable: "Ni podatkov na voljo",
      },
      characterStats: {
        loading: "Nalaganje statistike likov...",
        totalCharacters: "Skupno Likov",
        publicCharacters: "Javni Liki",
        averageRating: "Povprečna Ocena",
        traitRelationships: "Odnosi med Lastnostmi Likov",
        primaryTraitType: "Primarna Vrsta Lastnosti",
        secondaryTraitType: "Sekundarna Vrsta Lastnosti",
        selectTraitType: "Izberite vrsto lastnosti",
        personalityTraits: "Osebnostne Lastnosti",
        strengths: "Prednosti",
        weaknesses: "Slabosti",
        skills: "Veščine",
        noTraitData: "Ni podatkov o odnosih med lastnostmi",
        lessFrequent: "Manj pogosto",
        moreFrequent: "Bolj pogosto",
        usageDescription: "Prikazuje, kako pogosto se različne lastnosti pojavljajo skupaj v vaših likih",
        characters: "likov"
      },
      engagementStats: {
        loading: "Nalaganje statistike...",
        totalStories: "Skupno Zgodb",
        avgCustomization: "Povp. Prilagoditev",
        avgWordCount: "Povp. Število Besed",
        currentStreak: "Trenutni Niz",
        days: "dni",
        monthlyProgress: "Mesečni Napredek"
      }
    },    
    author: {
      title: 'Profil Avtorja',
      credits: 'Krediti za zgodbe',
      creditsAvailable: 'Na voljo imate {{count}} kreditov',
      memberSince: 'Član TaleCraft',
      loading: 'Nalaganje...',
      recentBadges: 'Nedavne značke',
      noBadgesYet: 'Še ni zasluženih značk',
      earnedOn: 'Zasluženo dne {{date}}',
      more: 'več'
    },
    access: {
      restricted: "Ta vsebina je omejena na uporabnike z naročnino.",
      loginRequired: "Za dostop do te vsebine se prijavite.",
    }
  }
};
